import { cloneDeep } from 'lodash';

export const updateVisibilityAndValidationOnNameChange = (entries, updatedFieldName, prevFieldName) => {
    let updatedEntries = entries ? cloneDeep(entries) : [];
    return updatedEntries.map((entry) => {
        if (entry.visibilityConditions) {
            (entry.visibilityConditions.all || entry.visibilityConditions.any).forEach((condition) => {
                if (condition.fact === prevFieldName) {
                    condition.fact = updatedFieldName;
                }
            });
        }
        if (entry.rules) {
            entry.rules.forEach((rule) => {
                (rule.conditions.all || rule.conditions.any).forEach((condition) => {
                    if (condition.fact === prevFieldName) {
                        condition.fact = updatedFieldName;
                    }
                });
            });
        }
        return entry;
    });
};
export const isFieldReferenced = (conditions, fieldName) => {
    let fieldNameReference = (conditions.all || conditions.any).find((condition) => condition.fact === fieldName);
    return fieldNameReference !== undefined;
};

export const checkFieldNameUsedInRules = (entries, deletedFieldName) => {
    let isReferenced = false;
    let referenceIndexes = [];
    entries.forEach((entry, index) => {
        let entryReferencesName = false;
        if (entry.visibilityConditions) {
            entryReferencesName = isFieldReferenced(entry.visibilityConditions, deletedFieldName);
        }
        if (entry.rules) {
            entry.rules.forEach((rule) => {
                entryReferencesName = isFieldReferenced(rule.conditions, deletedFieldName) || entryReferencesName;
            });
        }
        if (entryReferencesName) {
            referenceIndexes.push(index);
            isReferenced = true;
        }
    });
    return { fieldReferenced: isReferenced, referenceIndexes: referenceIndexes };
};

export const filterConditions = (conditions, fieldName) => {
    const conditionOperator = conditions.any ? 'any' : 'all';

    let filteredConditions = conditions[conditionOperator].filter((condition) => condition.fact !== fieldName);

    if (filteredConditions.length) {
        return { [conditionOperator]: filteredConditions };
    } else {
        return null;
    }
};

export const updateVisibilityAndValidationOnDelete = (entries, deletedFieldName, referenceIndexes) => {
    let updatedEntries = entries ? cloneDeep(entries) : [];
    referenceIndexes = referenceIndexes ?? [];
    referenceIndexes.forEach((referenceIndex) => {
        const fieldToUpdate = updatedEntries[referenceIndex];
        if (fieldToUpdate.visibilityConditions) {
            fieldToUpdate.visibilityConditions = filterConditions(fieldToUpdate.visibilityConditions, deletedFieldName);
        }
        if (fieldToUpdate.rules) {
            fieldToUpdate.rules.forEach((rule, index) => {
                fieldToUpdate.rules[index].conditions = filterConditions(rule.conditions, deletedFieldName);
            });
            fieldToUpdate.rules = fieldToUpdate.rules.filter((rule) => rule.conditions !== null);
        }
    });
    return updatedEntries;
};

export const stepBackActiveSection = (sections, activeSection) => {
    const calculatedActiveSection = activeSection - 1;
    if (calculatedActiveSection < 0 && sections.length) {
        return stepForwardActiveSection(sections, calculatedActiveSection);
    } else if (calculatedActiveSection >= sections.length) {
        return stepBackActiveSection(sections, calculatedActiveSection);
    } else if (sections.every((section) => section.form)) {
        return calculatedActiveSection;
    } else if (sections[calculatedActiveSection]?.form) {
        return stepBackActiveSection(sections, calculatedActiveSection);
    } else {
        return calculatedActiveSection;
    }
};

export const stepForwardActiveSection = (sections, activeSection) => {
    const calculatedActiveSection = activeSection + 1;
    if (calculatedActiveSection >= sections.length) {
        return stepBackActiveSection(sections, calculatedActiveSection);
    } else if (sections.every((section) => section.form)) {
        return calculatedActiveSection;
    } else if (sections[calculatedActiveSection]?.form) {
        return stepForwardActiveSection(sections, calculatedActiveSection);
    } else {
        return calculatedActiveSection;
    }
};
